import { Injectable, inject } from '@angular/core';
import { type UploadTask, ref, uploadBytesResumable, getDownloadURL, deleteObject, percentage, Storage } from '@angular/fire/storage';
import { collection, addDoc, collectionSnapshots, doc, deleteDoc, Firestore} from '@angular/fire/firestore';
import type {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import type {FileUpload} from './file-upload';

@Injectable({
    providedIn: 'root'
})
export class FileUploadService {
    private db = inject(Firestore);
    private storage = inject(Storage);

    private basePath = '/uploads';
    private collection = 'fileUploadInfo';
    private fileLists = null;

    pushFileToStorage(fileUpload: FileUpload): Observable<number | undefined> {
        const filePath = `${this.basePath}/${fileUpload.file.name}`;
        const storageRef = ref(this.storage, filePath);
        const uploadTask: UploadTask = uploadBytesResumable(storageRef, fileUpload.file);

        uploadTask.then(() => {
            getDownloadURL(storageRef).then(downloadURL => {
                fileUpload.url = downloadURL;
                fileUpload.name = fileUpload.file.name;
                this.saveFileData(fileUpload);
            });
        });

        return percentage(uploadTask).pipe(map(data => data.progress));
    }

    getFileList() {
        if (!this.fileLists) {
            this.fileLists = collectionSnapshots(collection(this.db, this.collection));
        }
        return this.fileLists;
    }

    deleteFile(fileUpload: FileUpload): void {
        this.deleteFileDatabase(fileUpload.key)
            .then(() => {
                this.deleteFileStorage(fileUpload.name);
            })
            .catch(error => console.warn(error));
    }

    private saveFileData(fileUpload: FileUpload): void {
        addDoc(collection(this.db, this.collection), {
            name: fileUpload.name,
            url: fileUpload.url,
            file: {
                lastModified: fileUpload.file.lastModified,
                name: fileUpload.file.name,
                size: fileUpload.file.size,
                type: fileUpload.file.type,
            }
        });
    }

    private deleteFileDatabase(key: string): Promise<void> {
        return deleteDoc(doc(this.db, this.collection, key));
    }

    private deleteFileStorage(name: string): void {
        const storageRef = ref(this.storage, `${this.basePath}/${name}`);
        deleteObject(storageRef);
    }
}
